// ===============================
// Vendor libraries
// ===============================

// ===============================
// Swiper imports
// ===============================
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

// Register modules
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

// Expose globally
window.Swiper = Swiper;

// ===============================
// Bootstrap imports
// ===============================
import * as bootstrap from "bootstrap";
import "@popperjs/core";
window.bootstrap = bootstrap;

// ===============================
// Sections
// ===============================
import "./sections/contact-form.js";
import "./sections/enquire-form.js";
import "./sections/sidebar.js";

// ===============================
// Animations (optional)
import "./animations/smooth-scroll.js";
import { render } from "sass";


document.addEventListener("DOMContentLoaded", () => {
  console.log("Site loaded!");

  // ------------------------------------------------------------
  // HEADER
  const header = document.querySelector('header');
  const scrollThreshold = 60;

  window.addEventListener('scroll', function () {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('header_fixed');
    } else {
      header.classList.remove('header_fixed');
    }
  });

  // ------------------------------------------------------------
  // SLIDERS  

  // OFFER SLIDER
  new Swiper("#offerSwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    dots: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 800,
    navigation: {
      nextEl: "#offerSwiper .swiper-button-next",
      prevEl: "#offerSwiper .swiper-button-prev",
    },
    pagination: {
      el: ".offerSwiper-pagination",
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      },
    },
  });

  // LENDING SLIDER
  new Swiper(".lendingSwiper", {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 60,
    speed: 1000,
    autoplay: {
      delay: 2000,
    },
    pagination: {
      el: ".lending-partner-pagination",
    },

  });

  // TESTIMONIAL SLIDER
  new Swiper("#testimonialSwiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    dots: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 800,
    navigation: {
      nextEl: "#testimonialSwiper .swiper-button-next",
      prevEl: "#testimonialSwiper .swiper-button-prev",
    },
    pagination: {
      el: ".testimonial-pagination",
    },
  });

  // BACK TO TOP BUTTON FUNCTION
  const backToTop = document.getElementById("backToTop");

  // Show/Hide button on scroll
  window.addEventListener("scroll", () => {
    if (window.scrollY > 400) {
      backToTop.classList.add("visible");
    } else {
      backToTop.classList.remove("visible");
    }
  });

  // Smooth scroll to top
  backToTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  // ------------------------------------------------------------
  // Check if custom cursor element exists
  if (document.querySelector(".custom-cursor")) {
    const cursor = document.querySelector(".custom-cursor__cursor");
    const cursorInner = document.querySelector(".custom-cursor__cursor-two");
    const links = document.querySelectorAll("a");
    const baseBg = document.querySelectorAll(".base_bg");

    // Move outer cursor
    document.addEventListener("mousemove", (e) => {
      cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
    });

    // Move inner cursor
    document.addEventListener("mousemove", (e) => {
      cursorInner.style.left = e.clientX + "px";
      cursorInner.style.top = e.clientY + "px";
    });

    // Mouse down effect
    document.addEventListener("mousedown", () => {
      cursor.classList.add("click");
      cursorInner.classList.add("custom-cursor__innerhover");
    });

    // Mouse up effect
    document.addEventListener("mouseup", () => {
      cursor.classList.remove("click");
      cursorInner.classList.remove("custom-cursor__innerhover");
    });

    // Hover effect on links
    links.forEach((link) => {
      link.addEventListener("mouseover", () => {
        cursor.classList.add("custom-cursor__hover");
      });
      link.addEventListener("mouseleave", () => {
        cursor.classList.remove("custom-cursor__hover");
      });
    });

    // Hover effect on white background elements
    baseBg.forEach((el) => {
      el.addEventListener("mouseover", () => {
        cursor.classList.add("custom-cursor-white__hover");
        cursorInner.classList.add("custom-cursor-white__innerhover");
      });
      el.addEventListener("mouseleave", () => {
        cursor.classList.remove("custom-cursor-white__hover");
        cursorInner.classList.remove("custom-cursor-white__innerhover");
      });
    });
  }

  // ------------------------------------------------------------

  const servicesContainer = document.getElementById('servicesContainer');
  const offerSwiper = document.getElementById('offerSwiper');
  if (servicesContainer || offerSwiper) {
    let servicesData = [];
    fetch('/assets/data/services.json')
      .then(response => response.json())
      .then(data => {
        servicesData = data;
        console.log('Services Data:', servicesData);
        if (servicesContainer) renderServices(servicesData);
        if (offerSwiper) renderServicesSlider(servicesData);
      })
      .catch(error => console.error('Error fetching services data:', error));

    function renderServices(services) {
      const servicesContainer = document.getElementById('servicesContainer');
      if (!servicesContainer) return;

      services.forEach(service => {
        let { id, name, description, img } = service;
        let template = `
                  <div class="col-12 col-md-4">
                      <div class="offer-card">
                          <img src="/assets/images/offer/${img}" alt="${name} image">
                          <h2 class="mb-3">${name}</h2>
                          <p class="text-ellipsis p-0">${description}</p>
                      </div>
                  </div>`;
        servicesContainer.innerHTML += template;
      });
    }

    function renderServicesSlider(services) {
      const offerSwiperWrapper = offerSwiper.querySelector('.swiper-wrapper');
      if (!offerSwiperWrapper) return;

      services.forEach(service => {
        let { id, name, description, img } = service;
        let template = `
                  <div class="swiper-slide">
                      <div class="offer-card">
                          <img src="/assets/images/offer/${img}" alt="${name} image">
                          <h2 class="mb-3">${name}</h2>
                          <p class="text-ellipsis p-0">${description}</p>
                          <a href="our-services.html" class="btn btn-primary rounded-pill">Know More</a>
                      </div>
                  </div>`;
        offerSwiperWrapper.innerHTML += template;
      });
    }
  }

  // ------------------------------------------------------------

});